import { liveUrl } from "../../utils/Constant";

const DocItem = ({ label, file }) => (
    <div className="doc-row">
        <span>{label}</span>
        {file ? (
            <a
                href={`${liveUrl}/download?filePath=${encodeURIComponent(file)}`}
                className="download-btn"
            >
                Download
            </a>
        ) : (
            <em>N/A</em>
        )}
    </div>
);
export default DocItem